// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var CONSOLE_TABLES = ["records", "ballots", "voters", "queue"];
export var PAGE_ORDERS = ["newest-first", "oldest-first"];
// The filters each table applies, as Harvest does: the others are ignored.
export var FILTERS_BY_TABLE = {
    records: [
        "statement_kind",
        "election_id",
        "user_id",
        "ballot_id",
        "created_after",
        "created_before",
    ],
    ballots: [
        "election_id",
        "area_id",
        "user_id",
        "ballot_id",
        "status",
        "created_after",
        "created_before",
    ],
    voters: ["election_id", "area_id", "user_id"],
    queue: ["election_id", "area_id"],
};
export var BALLOT_STATUSES = ["valid", "pending", "rejected"];
var DATE_FIELDS = ["created_after", "created_before"];
// The ballot box keys elections and areas by UUID; records keep them as text.
var UUID_FIELDS = ["election_id", "area_id"];
var UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
var filled = function (values, field) {
    var _a;
    var value = (_a = values[field]) === null || _a === void 0 ? void 0 : _a.trim();
    return value ? value : undefined;
};
/** The table's filters whose values the server would refuse. */
export var invalidFilters = function (table, values) {
    return FILTERS_BY_TABLE[table].filter(function (field) {
        var value = filled(values, field);
        if (value === undefined) {
            return false;
        }
        if (DATE_FIELDS.includes(field)) {
            return Number.isNaN(Date.parse(value));
        }
        return table !== "records" && UUID_FIELDS.includes(field) && !UUID_PATTERN.test(value);
    });
};
/** The filters of a page request: the table's filled values, dates in seconds. */
export var toConsoleFilters = function (table, values) {
    var filters = {};
    for (var _i = 0, _a = FILTERS_BY_TABLE[table]; _i < _a.length; _i++) {
        var field = _a[_i];
        var value = filled(values, field);
        if (value === undefined) {
            continue;
        }
        if (field === "created_after" || field === "created_before") {
            filters[field] = Math.floor(Date.parse(value) / 1000);
        }
        else {
            filters[field] = value;
        }
    }
    return filters;
};
export var isQueryError = function (result) {
    return typeof result.error === "string";
};
/** The election events of a tenant, or none if the tenant is unknown. */
export var tenantEvents = function (tenants, tenantId) { var _a, _b; return (_b = (_a = tenants.find(function (tenant) { return tenant.id === tenantId; })) === null || _a === void 0 ? void 0 : _a.events) !== null && _b !== void 0 ? _b : []; };
/** The elections of an election event of a tenant, or none if either is unknown. */
export var eventElections = function (tenants, tenantId, eventId) { var _a, _b; return (_b = (_a = tenantEvents(tenants, tenantId).find(function (event) { return event.id === eventId; })) === null || _a === void 0 ? void 0 : _a.elections) !== null && _b !== void 0 ? _b : []; };
export var ROW_ID = "__row";
/** The grid field of a column: by position, since a query may repeat a name. */
export var columnField = function (index) { return "c".concat(index); };
/** Rows as objects for a data grid, numbered from `offset`. */
export var toGridRows = function (_a, offset) {
    var columns = _a.columns, rows = _a.rows;
    if (offset === void 0) { offset = 0; }
    return rows.map(function (row, index) {
        var _a;
        var object = (_a = {}, _a[ROW_ID] = offset + index, _a);
        columns.forEach(function (_, column) {
            var _a;
            object[columnField(column)] = (_a = row[column]) !== null && _a !== void 0 ? _a : null;
        });
        return object;
    });
};
/** How a value shows in a cell. */
export var displayValue = function (value) {
    if (value === null || value === undefined) {
        return "";
    }
    if (typeof value === "object") {
        return JSON.stringify(value);
    }
    return String(value);
};
